
import React, { useState, useEffect } from "react";
import FoodImage from "../images/food.jpeg";
import Banner from "../images/banner.png";
import "../styles/home.css";

import {
    Grid,
    CardMedia,
    Container,
    Card,
    CardContent,
    CardHeader,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tabs,
    Tab,
    Box,
    Button,
    TextField,
    MenuItem,
    Snackbar, Alert
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import axiosInstance from "../axiosConfig";
const API_BASE_URL = process.env.REACT_APP_API_SERVICE;



const EmployeeList = () => {
    const [employees, setEmployees] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    }
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0); // resetting to the first page.
    }


    useEffect(() => {
        axiosInstance.get(`${API_BASE_URL}/employees`).then(response => {
            setEmployees(response.data);
        })
    }, []);

    return (
        <Card>
            <CardHeader title="Employees" />
            <CardContent>
                <TableContainer sx={{border : "1px solid #ccc"}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Hourly Rate</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { employees.slice(page*rowsPerPage, page*rowsPerPage+rowsPerPage).map((emp) => (
                                <TableRow key={emp.employeeId}>
                                <TableCell>{emp.employeeId}</TableCell>
                                <TableCell>{emp.name}</TableCell>
                                <TableCell>{emp.phone}</TableCell>
                                <TableCell>{emp.email}</TableCell>
                                <TableCell>${emp.hourlyRate}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                </TableContainer>
                <TablePagination component="div" count={employees.length}
                                 onPageChange={handlePageChange}
                                 page={page} rowsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                rowsPerPageOptions={[5,10,15]}/>
            </CardContent>
        </Card>
    );
};

const PayoutList = () => {
    const [payouts, setPayouts] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    }
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0); // resetting to the first page.
    }
    useEffect(() => {
        axiosInstance.get(`${API_BASE_URL}/employees/payouts`).then(response => {setPayouts(response.data);})

    }, []);

    return (
        <Card>
            <CardHeader title="Payouts" />
            <CardContent>
                <TableContainer sx={{border : "1px solid #ccc"}}>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Payout ID</TableCell>
                                <TableCell>Employee ID</TableCell>
                                <TableCell>Hours Worked</TableCell>
                                <TableCell>Total Amount</TableCell>
                                <TableCell>Payout Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { payouts.slice(page*rowsPerPage, page*rowsPerPage+rowsPerPage).map((p) => (
                                <TableRow key={p.payoutId}>
                                    <TableCell>{p.payoutId}</TableCell>
                                    <TableCell>{p.employeeName}</TableCell>
                                    <TableCell>{p.hoursWorked}</TableCell>
                                    <TableCell>${p.totalAmount}</TableCell>
                                    <TableCell>{p.payoutDate}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination component="div" count={payouts.length}
                                 onPageChange={handlePageChange}
                                 page={page} rowsPerPage={rowsPerPage}
                                 onPageChange={handlePageChange}
                                 onRowsPerPageChange={handleRowsPerPageChange}
                                 rowsPerPageOptions={[5,10,15]}/>
            </CardContent>
        </Card>
    );
};

const AddEmployee = ({ setSnackbarMessage, setSnackbarSeverity, setSnackbarOpen }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [position, setPosition] = useState("");
    const [hourlyRate, setHourlyRate] = useState("");
    const [employee, setEmployee] = useState({
        name: '',
        email: '',
        phone:'',
        position:'',
        hourlyRate: null
        });

    const handleChange = (event) => {
        setEmployee({
            ...employee,
            [event.target.name]: event.target.value
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        await axiosInstance.post(`${API_BASE_URL}/employees/create`, {setEmployee})
        setSnackbarMessage("Employee Added successfully!")
        setSnackbarSeverity("success")
        setSnackbarOpen(true)
        setName("");
        setEmail("");
        setPhone("");
        setPosition("");
        setHourlyRate("");
    };

    return (
        <Card>
            <CardHeader title="Add Employee" />
            <CardContent>
                <form onSubmit={handleSubmit}>
                    <TextField label="Name" value={employee.name} onChange={handleChange} fullWidth margin="normal" required />
                    <TextField label="Email" type="email" value={employee.email} onChange={handleChange} fullWidth margin="normal" required />
                    <TextField label="Phone" value={employee.phone} onChange={handleChange} fullWidth margin="normal" />
                    <TextField label="Position" value={employee.position} onChange={handleChange} fullWidth margin="normal" />
                    <TextField label="Hourly Rate" type="number" value={employee.hourlyRate} onChange={handleChange} fullWidth margin="normal" required />
                    <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 2 }}>
                        Submit
                    </Button>
                </form>
            </CardContent>
        </Card>
    );
};

const AddPayout = ({ setSnackbarMessage, setSnackbarSeverity, setSnackbarOpen }) => {
    const [employees, setEmployees] = useState([]);
    const [employeeId, setEmployeeId] = useState("");
    const [hoursWorked, setHoursWorked] = useState("");

    useEffect(() => {

        axiosInstance.get(`${API_BASE_URL}/employees`).then(response => {
            setEmployees(response.data)
        })
    },[]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        const employeePayout ={
            employeeId:employeeId,
            hoursWorked:hoursWorked
        }
        await axiosInstance.post(`${API_BASE_URL}/employees/payout`, {
            ...employeePayout// Set current datetime
        });

        setSnackbarMessage("PayOut Added successfully!")
        setSnackbarSeverity("success")
        setSnackbarOpen(true)
        setEmployeeId("");
        setHoursWorked("");
    };

    return (
        <Card>
            <CardHeader title="Add Payout" />
            <CardContent>
                <form onSubmit={handleSubmit}>
                    <TextField select label="Employee" value={employeeId} onChange={(e) => setEmployeeId(e.target.value)} fullWidth margin="normal">
                        {employees.map((emp) => (
                            <MenuItem key={emp.employeeId} value={emp.employeeId}>
                                {emp.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField label="Hours Worked" type="number" value={hoursWorked} onChange={(e) => setHoursWorked(e.target.value)} fullWidth margin="normal" />
                    <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 2 }}>
                        Submit
                    </Button>
                </form>
            </CardContent>
        </Card>
    );
};

const Pricing = () => {
    const pricingData = [
        { title: 'Veg Curry Box', price: '$12.49', description: 'Includes rice, curry, and sides.' },
        { title: 'Non-Veg Curry Box', price: '$13.49', description: 'Includes Dal/Sambar, Non-Veg Curry and Veg Fry.\n' +
                'Available in Regular and Family sizes' },
        { title: 'Veg Meal Box', price: '$9.99', description: 'Includes dal, rice, chips, and curd.' },
        { title: 'Non-Veg Meal Box', price: '$11.99', description: 'Includes dal, rice, non-veg, and sides.' },
    ];

    return (
        <Container>
            <Typography variant="h2" gutterBottom align="center">Pre-Order Your Meal</Typography>
            <Typography variant="h6" gutterBottom align="center">Nag's Kitchen offers a variety of healthy & homemade curries, meal boxes,
                snacks, batters, and much more. Our menu features wholesome options crafted with fresh ingredients, ensuring every bite is nourishing and delicious.</Typography>

            <Grid container spacing={4} justifyContent="center">
                {pricingData.map((item, index) => (
                    <Grid item key={index} xs={12} sm={6} md={3} sx={{height: '500px'}}>
                        <Card sx={{backgroundColor: 'lightblue', height:'400px'}}>

                            <CardMedia
                                component="img"
                                height="140"
                                image={FoodImage}
                                alt={item.title}
                            />
                            <CardContent>
                                <Typography variant="h5">{item.title}</Typography>
                                <Typography variant="h6" color="primary">{item.price}</Typography>

                                <Typography variant="body2">{item.description}</Typography>
                                <Box mt={2}>
                                    <Button variant="contained" color="primary">Pre Order Now</Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};


const EmployeePayoutApp = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState("")
    const [snackbarSeverity, setSnackbarSeverity] = useState('success')

    const handleSnackbarClose = () => {
        setSnackbarOpen(false)
    }

    return (
        <Box sx={{ width: "100%", padding: 2 }}>
            <Tabs value={tabIndex} onChange={(e, newValue) => setTabIndex(newValue)}>
                <Tab label="Employees" />
                <Tab label="Payouts" />
                <Tab label="Add Employee" />
                <Tab label="Add Payout" />
                <Tab label="Pricing" />

            </Tabs>
            <Box sx={{ marginTop: 2 }}>
                {tabIndex === 0 && <EmployeeList />}
                {tabIndex === 1 && <PayoutList />}
                {tabIndex === 2 && <AddEmployee setSnackbarMessage={setSnackbarMessage}
                                                setSnackbarSeverity={setSnackbarSeverity}
                                                setSnackbarOpen={setSnackbarOpen}/>}
                {tabIndex === 3 && <AddPayout setSnackbarMessage={setSnackbarMessage}
                                              setSnackbarSeverity={setSnackbarSeverity}
                                              setSnackbarOpen={setSnackbarOpen}/>}
                {tabIndex === 4 && <Pricing />}
            </Box>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                sx={{ zIndex: 2000 }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        minHeight: '80px'
                    }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};



export default EmployeePayoutApp;
